import React from 'react';
import { Tooltip, Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import moment from 'moment-timezone';
import { DATE_FORMAT_IN_READABLE_FORMAT } from '../../config/DateTimeConstants';

export default function DisplayNewBookingDetails({ selectedChildName, currentServiceType, bookingStatus, selectedTimeslot, contentName, reasonCode }) {

  const headerLabelStyle = { fontWeight: 'bold', mt: 2, mb: 1 };
  const valueStyle = { mt: 2, mb: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }

  return (
    <Grid container spacing={1}>

      <Grid size={3}>
        <Typography variant="body1" sx={headerLabelStyle}>Child:</Typography>
      </Grid>

      <Grid size={8}>
        <Typography variant="body1" sx={valueStyle}>{selectedChildName}</Typography>
      </Grid>

      <Grid size={3}>
        <Typography variant="body1" sx={headerLabelStyle}>Service Type:</Typography>
      </Grid>

      <Grid size={3}>
        <Typography variant="body1" sx={valueStyle}>{currentServiceType}</Typography>
      </Grid>

      <Grid size={2}>
        <Typography variant="body1" sx={headerLabelStyle}>Content:</Typography>
      </Grid>

      <Grid size={4}>
        {contentName.map((name, index) => (
          <Typography key={index} variant="body1" sx={valueStyle}>{name}</Typography>
        ))}
      </Grid>

      <Grid size={3}>
        <Typography variant="body1" sx={headerLabelStyle}>Timeslot:</Typography>
      </Grid>

      <Grid size={8}>
        <Typography variant="body1" sx={valueStyle}>{moment(selectedTimeslot).format(DATE_FORMAT_IN_READABLE_FORMAT)}</Typography>
      </Grid>

      <Grid size={3}>
        <Typography variant="body1" sx={headerLabelStyle}>Booking Status:</Typography>
      </Grid>

      <Grid size={3}>
        <Typography variant="body1" sx={valueStyle}>{bookingStatus}</Typography>
      </Grid>

      <Grid size={2}>
        <Typography variant="body1" sx={headerLabelStyle}>Reason Code:</Typography>
      </Grid>

      <Grid size={4}>
        <Tooltip title={reasonCode}>
          <Typography variant="body1" sx={{ ...valueStyle, maxWidth: '50%' }}>
            {reasonCode}
          </Typography>
        </Tooltip>
      </Grid>
    </Grid>
  );
}
